import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=01c7bd90&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=01c7bd90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7bd90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c7bd90')) {
      api.createRecord('01c7bd90', component.options)
    } else {
      api.reload('01c7bd90', component.options)
    }
    module.hot.accept("./PaymentSettings.vue?vue&type=template&id=01c7bd90&scoped=true", function () {
      api.rerender('01c7bd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userSettings/PaymentSettings.vue"
export default component.exports